import { forwardRef, InputHTMLAttributes } from 'react'

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string
  error?: string
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, error, className = '', id, ...props }, ref) => {
    const checkboxId = id || `checkbox-${Math.random().toString(36).substr(2, 9)}`

    return (
      <div className={className}>
        <label htmlFor={checkboxId} className="flex items-center gap-2 cursor-pointer">
          <input
            ref={ref}
            type="checkbox"
            id={checkboxId}
            className={`
              h-4 w-4 rounded
              border-slate-300 dark:border-slate-600
              text-primary-600
              focus:ring-primary-500 focus:ring-offset-0
              dark:bg-slate-800 dark:checked:bg-primary-600
              transition-colors
              ${error ? 'border-red-500' : ''}
            `}
            {...props}
          />
          {label && (
            <span className="text-sm text-slate-700 dark:text-slate-300">{label}</span>
          )}
        </label>
        {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
      </div>
    )
  }
)

Checkbox.displayName = 'Checkbox'
